import { useEffect, useState } from 'react';

/**
 * Hook used for calculating the height of the page header.
 */
export const useHeaderHeight = (shouldUse = true) => {
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    if (shouldUse) {
      const headerElement = document.getElementById('header-wrapper-id');
      const disclaimerElement = document.getElementById('disclaimer-wrapper-id');

      if (headerElement) {
        const resizeObserver = new ResizeObserver((entries) => {
          const currentHeaderHeight = entries[0].contentRect.height;
          const disclaimerHeight = disclaimerElement?.offsetHeight ?? 0;
          const totalHeight = currentHeaderHeight + disclaimerHeight;

          if (totalHeight !== headerHeight) {
            setHeaderHeight(totalHeight);
          }
        });
        resizeObserver.observe(headerElement);
        return () => {
          resizeObserver.disconnect();
        };
      }
    }
    return () => {};
  }, [headerHeight, shouldUse]);

  return { headerHeight, setHeaderHeight };
};
